import React, { Component } from 'react';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import EkoSpinner from "../../components/elements/EkoSpinner";
import AddCompanyBranch from './AddCompanyBranch';
import Api from '../../util/Api';

class CompanyBranch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            records: [],
            formData: {},
            page_loading: true,
            showInsertModal: false,
            errors: {},
        };
    }

    componentWillMount() {
        this.fetchRecordedData();
    }

    fetchRecordedData() {
        this.setState({ page_loading: false, showInsertModal: false, formData: {}, records: [] });
        Api.get("/company/getCompanyBranches", (response, errors) => {
            if (errors) return;
            if(response && response.companies!==null){
                this.setState({ records: response.data, page_loading: false });
            }
        });
    }

    onSave() {
        this.fetchRecordedData();
    }

    openPopup() {
        this.setState({ showInsertModal: true,formData: {} });
    }

    deleteRecord(itemId) {
        toastr.confirm('Kayıt silinecektir. Onaylıyor musunuz?', {
            onOk: () => {
                Api.put("/company/deleteCompanyBranch", { id: itemId }, (response, errors) => {
                    if (errors) {
                        toastr.error("Hata", "Kayıt silinirken bir hata oluştu.");
                    } else {
                        toastr.success("Başarılı", "Kayıt silindi.");
                        this.fetchRecordedData();
                    }
                });
            },
            onCancel: () => {},
            okText: "Evet",
            cancelText: "Hayır"
        });
    }

    editRecord(itemId) {
        Api.get(`/company/getCompanyBranchDetails/${itemId}`, (response, errors) => {
            if (errors) return;
            this.setState({ formData: response.data, showInsertModal: true });
        });
    }

    render() {
        return (
            <div>
                {this.state.page_loading ? <EkoSpinner /> :
                    <>
                        <AddCompanyBranch
                            showModal={this.state.showInsertModal}
                            editData={this.state.formData}
                            onSave={() => {
                                this.setState({ showInsertModal: false });
                                this.fetchRecordedData();
                            }}
                            onCancel={() => {
                                this.setState({ showInsertModal: false });
                            }}
                            errors={this.state.errors}
                        />

                        <div style={{ textAlign: "right" }} onClick={this.openPopup.bind(this)}>
                            <button type='button' className='btn btn-default blue btn-sm'>
                                <i className='fa fa-plus'></i>Yeni Ekle
                            </button>
                        </div>

                        <table className='table table-striped'>
                            <thead>
                                <tr>
                                    <th>Şube Adı</th>
                                    <th>Telefon</th>
                                    <th>Email</th>
                                    <th>Adres</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(this.state.records) && this.state.records.length!==0 && this.state.records.map(record =>
                                    <tr key={record.id}>
                                        <td>{record.name}</td>
                                        <td>{record.phone}</td>
                                        <td>{record.email}</td>
                                        <td>{record.address}</td>
                                        <td>
                                            <button type='button' className='btn btn-sm btn-warning' onClick={() => this.editRecord(record.id)}><i className='fa fa-edit'></i></button>
                                            <button type='button' className='btn btn-sm btn-danger' onClick={() => this.deleteRecord(record.id)}><i className='fa fa-trash'></i></button>
                                        </td>
                                    </tr>
                                )}
                                {this.state.records.length === 0 &&
                                    <tr><td colSpan={5} style={{ textAlign: "center" }}>Kayıt bulunamadı</td></tr>
                                }
                            </tbody>
                        </table>
                    </>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        records: state.data.records
    };
}

export default connect(mapStateToProps, actions)(CompanyBranch);